/* Vibe size recommender — height + weight + build -> size, from a JSON chart.
   Chart shape: { "sizes": [ { "size": "M", "height": [172,182], "weight": [68,82] }, ... ] }
   Product metafield custom.size_chart overrides shop default (wild.size_chart_default).
   Result messages are localised in the Liquid block and passed in via data- attributes
   (data-msg-need / data-msg-rec / data-msg-adj / data-msg-none) so the tool speaks
   the shop language (EN / FI / DE) with no strings hardcoded here. */
(function () {
  function score(entry, h, w) {
    const hm = (entry.height[0] + entry.height[1]) / 2;
    const wm = (entry.weight[0] + entry.weight[1]) / 2;
    const hr = (entry.height[1] - entry.height[0]) / 2 || 1;
    const wr = (entry.weight[1] - entry.weight[0]) / 2 || 1;
    return Math.pow((h - hm) / hr, 2) + Math.pow((w - wm) / wr, 2);
  }

  function recommend(chart, h, w, build) {
    const sizes = chart.sizes || [];
    if (!sizes.length) return null;
    let bestIdx = 0;
    let best = Infinity;
    sizes.forEach((s, i) => {
      const sc = score(s, h, w);
      if (sc < best) { best = sc; bestIdx = i; }
    });
    const s = sizes[bestIdx];
    const nearUpper = w >= s.weight[1] - (s.weight[1] - s.weight[0]) * 0.2;
    const nearLower = w <= s.weight[0] + (s.weight[1] - s.weight[0]) * 0.2;
    let idx = bestIdx;
    if (build === 'athletic' && nearUpper && bestIdx < sizes.length - 1) idx = bestIdx + 1;
    if (build === 'lean' && nearLower && bestIdx > 0) idx = bestIdx - 1;
    return { size: sizes[idx].size, borderline: idx !== bestIdx };
  }

  function init(panel) {
    if (panel.dataset.vibeSizerInit) return;
    panel.dataset.vibeSizerInit = '1';
    let chart;
    try { chart = JSON.parse(panel.dataset.chart); } catch (e) { return; }
    const msg = {
      need: panel.dataset.msgNeed || 'Enter your height and weight first.',
      rec: panel.dataset.msgRec || 'Our recommendation:',
      adj: panel.dataset.msgAdj || ' — adjusted for your build.',
      none: panel.dataset.msgNone || 'No sizing data available for this product yet.'
    };
    const btn = panel.querySelector('[data-sizer-go]');
    const out = panel.querySelector('[data-sizer-result]');
    btn.addEventListener('click', () => {
      const h = parseFloat(panel.querySelector('[data-sizer-height]').value);
      const w = parseFloat(panel.querySelector('[data-sizer-weight]').value);
      const build = panel.querySelector('[data-sizer-build]').value;
      if (!h || !w) {
        out.hidden = false;
        out.textContent = msg.need;
        return;
      }
      const rec = recommend(chart, h, w, build);
      out.hidden = false;
      if (rec) {
        const adj = rec.borderline ? msg.adj : '';
        out.innerHTML = msg.rec + ' <strong>' + rec.size + '</strong>' + adj;
      } else {
        out.textContent = msg.none;
      }
    });
  }

  function boot() { document.querySelectorAll('[data-vibe-sizer]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
